import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { DimsUom, VolumesUom, Convert } from '@library/common/models';

@Pipe({ name: 'dualvolume' })
export class DualVolumePipe implements PipeTransform {
   constructor( @Inject(LOCALE_ID) private locale: string) { }

   transform( value: number, valueIs: VolumesUom = VolumesUom[0], order: string[] = [ 'cft', 'cbm' ]): string | null {
      if ( !valueIs ) { valueIs = VolumesUom[0]; }
      const decimal = new DecimalPipe( this.locale );

      const values = {
         cft: decimal.transform( Convert( value, valueIs, 'cft' ).toFixed( 2 )) + ' cft',
         cbm: decimal.transform( Convert( value, valueIs, 'cbm' ).toFixed( 2 )) + ' cbm',
      }

      return order.map( o => values[o] ).filter( _ => !!_ ).join( ', ' );
   }
}

@Pipe({ name: 'totalvolume' })
export class TotalVolumePipe implements PipeTransform {
   transform( value: { length?: number, width?: number, height?: number, pieces?: number, measure_type: DimsUom }[], output: VolumesUom = 'cft' ): number {
      const volProp = prop => prop === 'cft' ? 'ft' : 'm';

      return value.map( item => {
         return [ item.length, item.width, item.height ]
            .map( dim => Convert( dim, item.measure_type, volProp( output )))
            .reduce(( a, c ) => a * c ) * item.pieces || 0;
      }).reduce(( a, c ) => a + c, 0 );
   }
}

@Pipe({ name: 'totaldualvolume' })
export class TotalDualVolumePipe implements PipeTransform {
   constructor( @Inject(LOCALE_ID) private locale: string) { }

   transform( value: { length?: number, width?: number, height?: number, measure_type: DimsUom }[] ): string {
      const dual = new DualVolumePipe( this.locale );
      const total = new TotalVolumePipe();

      const vol_types = value.filter( item => item?.length && item?.width && item?.height ).map( item => item.measure_type );
      const counts = {
         cft: vol_types.filter( t => t === 'ft' || t === 'in' ).length,
         cbm: vol_types.filter( t => t === 'm' || t === 'cm' ).length,
      };

      if ( counts.cft >= counts.cbm ) {
         return dual.transform( total.transform( value, 'cft' ), 'cft', [ 'cft', 'cbm' ]);
      } else {
         return dual.transform( total.transform( value, 'cbm' ), 'cbm', [ 'cbm', 'cft' ]);
      }
   }
}
